<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1 class="text-center">Panel</h1>
    </div>

    <br>
    <el-row :gutter="24" class="mt-4">


        <el-row :gutter="24" class="mt-4">

          <el-col :span="6">
            <el-card shadow="always">
              Toplam Bina
              <apexchart type="radialBar" height=200 :options="options" :series="series"></apexchart>
            </el-card>
          </el-col>

          <el-col :span="6">
            <el-card shadow="always">
              Toplam Asansör
              <apexchart type="radialBar" height=200 :options="options" :series="series1"></apexchart>
            </el-card>
          </el-col>

          <el-col :span="6">
            <el-card shadow="always">
              Toplam Bakım Sayısı
              <apexchart type="radialBar" height=200 :options="options" :series="series2"></apexchart>
            </el-card>
          </el-col>

          <el-col :span="6">
            <el-card shadow="always">
              Şuan Bakım Yapılan Asansörler
              <apexchart type="radialBar" height=200 :options="options" :series="series3"></apexchart>
            </el-card>
          </el-col>

        </el-row>

      <br>
      <hr>

      <el-col :span="8">
        <h3>Kritik Ürün Stokları</h3>
        <el-card shadow="always">
          <div class="block">
            <el-timeline style="padding: 0">
              <el-timeline-item
                  v-for="(activity, index) in Uruns"
                  :key="index"
                  :icon="activity.icon"
                  :type="activity.type"
                  :color="activity.color"
                  :size="activity.size"
                  :timestamp="activity.timestamp">
                {{ activity.content }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <h3>Bakımı Devam Eden Asansörler</h3>
        <el-card shadow="always">
          <div class="block">
            <el-timeline style="padding: 0">
              <el-timeline-item
                  v-for="(activity, index) in activities"
                  :key="index"
                  :icon="activity.icon"
                  :type="activity.type"
                  :color="activity.color"
                  :size="activity.size"
                  :timestamp="activity.timestamp">
                {{ activity.content }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-card>
      </el-col>

      <el-col :span="8">
        <h3>Bina Bakım Günleri</h3>
        <el-card shadow="always">
          <div class="block">
            <el-timeline style="padding: 0">
              <el-timeline-item
                  v-for="(activity, index) in activities1"
                  :key="index"
                  :icon="activity.icon"
                  :type="activity.type"
                  :color="activity.color"
                  :size="activity.size"
                  :timestamp="activity.timestamp">
                {{ activity.content }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-card>
      </el-col>

    </el-row>


  </div>

</template>

<script>
export default {
  data() {
    return {
      camera: false,
      options: {
        chart: {
          toolbar: {
            show: false
          }
        },
        colors: ['#2e9dd2'],

        plotOptions: {


          radialBar: {


            hollow: {
              margin: 0,
              size: '90%',
              background: 'transparent',
              position: 'front',
              dropShadow: {
                enabled: false,
                top: 3,
                left: 0,
                blur: 4,
                opacity: 0.24
              },
            },
            track: {
              background: '#fff',
              strokeWidth: '67%',
              margin: 0, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 0,
                left: 0,
                blur: 0,
                opacity: 0.35
              },

            },

            dataLabels: {
              name: {
                offsetY: -10,
                show: false,
                color: '#fff',
                fontSize: '17px'
              },
              value: {
                formatter: function (val) {
                  return parseInt(val);
                },
                color: '#111',
                fontSize: '36px',
                show: true,
              }
            }
          }
        },
        fill: {
          color: ['#000'],
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            shadeIntensity: 0.5,
            gradientToColors: ['#000'],
            inverseColors: true,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 100]
          }
        },
        stroke: {
          lineCap: 'round'
        },
        labels: [''],
      },
      series: [0],
      series1: [0],
      series2: [0],
      series3: [0],
      Uruns: [],
      activities: [],
      activities1: [],
      saats: null

    }
  },
  created() {
    this.$store.dispatch("title", "Panel");
    this.$store.dispatch("Get", {path: 'panel'})
        .then(response => {
          if (response.Durum === "OK") {
            this.Uruns = response.Data.Uruns
            this.activities = response.Data.Bakim
            this.activities1 = response.Data.bakimtarih
            this.series[0] = response.Data.Bina
            this.series1[0] = response.Data.asansor
            this.series2[0] = response.Data.bakimcount
            this.series3[0] = response.Data.bakimscount
          } else {
            this.$notify.error({
              title: response.Mesaj,
              customClass: 'error'
            });
            this.lo = false
          }
        })

  },
  methods: {}

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Panel/Index.vue